import { FileText } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import type { OrderLink } from '@/pages/OrderLinkPage'

export function InvoiceStatus({ invoice }: { invoice: OrderLink['invoice'] }) {
  if (!invoice) {
    return (
      <Card>
        <CardContent className="flex items-center gap-3 px-4 py-3">
          <FileText className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
          <p className="text-body-sm font-medium">No invoice · Free order</p>
        </CardContent>
      </Card>
    )
  }

  const payable = invoice.payment_link_url !== null

  return (
    <Card className={payable ? 'bg-primary/5' : undefined}>
      <CardContent className="flex flex-wrap items-center gap-3 px-4 py-3">
        <FileText className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden="true" />
        <div className="min-w-32 flex-1">
          <p className="text-body-sm font-medium">Invoice #{invoice.number}</p>
          <p className="text-caption text-muted-foreground">{invoice.status}</p>
        </div>
        <p className="text-body-sm font-medium tabular-nums">{invoice.balance}</p>
        {invoice.payment_link_url && (
          <Button asChild className="h-8 px-3">
            <a href={invoice.payment_link_url}>Pay now</a>
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
